<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
                  <a-form-model-item prop="publisherId" >
                        <span slot="label" ><a-tooltip>发布用户ID<template slot="title">发布用户ID</template></a-tooltip> </span>
                        <a-input v-model="form.publisherId"  :placeholder="$t('通用.输入.请输入')+'发布用户ID'" />
                  </a-form-model-item>
                  <a-form-model-item prop="taskTitle" >
                        <span slot="label" ><a-tooltip>任务标题<template slot="title">任务标题</template></a-tooltip> </span>
                        <a-input v-model="form.taskTitle" :maxLength="100" :placeholder="$t('通用.输入.请输入')+'任务标题'" />
                  </a-form-model-item>
                  <a-form-model-item prop="taskDesc" >
                        <span slot="label" ><a-tooltip>任务描述<template slot="title">任务描述</template></a-tooltip> </span>
                        <a-input v-model="form.taskDesc" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item prop="taskVideoUrl" >
                        <span slot="label" ><a-tooltip>任务视频地址<template slot="title">任务视频地址</template></a-tooltip> </span>
                        <a-input v-model="form.taskVideoUrl" :maxLength="255" :placeholder="$t('通用.输入.请输入')+'任务视频地址'" />
                  </a-form-model-item>
                  <a-form-model-item prop="taskVideoCover" >
                        <span slot="label" ><a-tooltip>视频封面图<template slot="title">视频封面图</template></a-tooltip> </span>
                        <a-input v-model="form.taskVideoCover" :maxLength="255" :placeholder="$t('通用.输入.请输入')+'视频封面图'" />
                  </a-form-model-item>
                  <a-form-model-item prop="voteCount" >
                        <span slot="label" ><a-tooltip>投放票数<template slot="title">投放票数</template></a-tooltip> </span>
                        <a-input v-model="form.voteCount"  :placeholder="$t('通用.输入.请输入')+'投放票数'" />
                  </a-form-model-item>
                  <a-form-model-item prop="usedVoteCount" >
                        <span slot="label" ><a-tooltip>已使用票数<template slot="title">已使用票数</template></a-tooltip> </span>
                        <a-input v-model="form.usedVoteCount"  :placeholder="$t('通用.输入.请输入')+'已使用票数'" />
                  </a-form-model-item>
                  <a-form-model-item prop="remainVoteCount" >
                        <span slot="label" ><a-tooltip>剩余票数<template slot="title">剩余票数</template></a-tooltip> </span>
                        <a-input v-model="form.remainVoteCount"  :placeholder="$t('通用.输入.请输入')+'剩余票数'" />
                  </a-form-model-item>
                  <a-form-model-item prop="province" >
                        <span slot="label" ><a-tooltip>省<template slot="title">省</template></a-tooltip> </span>
                        <a-input v-model="form.province" :maxLength="50" :placeholder="$t('通用.输入.请输入')+'省'" />
                  </a-form-model-item>
                  <a-form-model-item prop="city" >
                        <span slot="label" ><a-tooltip>市<template slot="title">市</template></a-tooltip> </span>
                        <a-input v-model="form.city" :maxLength="50" :placeholder="$t('通用.输入.请输入')+'市'" />
                  </a-form-model-item>
                  <a-form-model-item prop="district" >
                        <span slot="label" ><a-tooltip>区<template slot="title">区</template></a-tooltip> </span>
                        <a-input v-model="form.district" :maxLength="50" :placeholder="$t('通用.输入.请输入')+'区'" />
                  </a-form-model-item>
                  <a-form-model-item prop="detailAddress" >
                        <span slot="label" ><a-tooltip>详细地址<template slot="title">详细地址</template></a-tooltip> </span>
                        <a-input v-model="form.detailAddress" :maxLength="255" :placeholder="$t('通用.输入.请输入')+'详细地址'" />
                  </a-form-model-item>
                  <a-form-model-item prop="taskType" >
                        <span slot="label" ><a-tooltip>任务类型<template slot="title">任务类型</template></a-tooltip> </span>
                  </a-form-model-item>
                  <a-form-model-item prop="taskCategory" >
                        <span slot="label" ><a-tooltip>任务类别<template slot="title">任务类别</template></a-tooltip> </span>
                        <a-input v-model="form.taskCategory" :maxLength="50" :placeholder="$t('通用.输入.请输入')+'任务类别'" />
                  </a-form-model-item>
                  <a-form-model-item prop="identityTags" >
                        <span slot="label" ><a-tooltip>身份标签，逗号分隔，如:kTv,男,25岁,本科,舞蹈老师<template slot="title">身份标签，逗号分隔，如:kTv,男,25岁,本科,舞蹈老师</template></a-tooltip> </span>
                        <a-input v-model="form.identityTags" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item prop="viewPermission" >
                        <span slot="label" ><a-tooltip>查看权限 1公开 2部分可见 3私密<template slot="title">查看权限 1公开 2部分可见 3私密</template></a-tooltip> </span>
                        <a-input v-model="form.viewPermission"  :placeholder="$t('通用.输入.请输入')+'查看权限 1公开 2部分可见 3私密'" />
                  </a-form-model-item>
                  <a-form-model-item prop="estimatedArrivalMinutes" >
                        <span slot="label" ><a-tooltip>预计到达时间(分钟)<template slot="title">预计到达时间(分钟)</template></a-tooltip> </span>
                        <a-input v-model="form.estimatedArrivalMinutes"  :placeholder="$t('通用.输入.请输入')+'预计到达时间(分钟)'" />
                  </a-form-model-item>
                  <a-form-model-item prop="taskPrice" >
                        <span slot="label" ><a-tooltip>任务价格<template slot="title">任务价格</template></a-tooltip> </span>
                        <a-input v-model="form.taskPrice"  :placeholder="$t('通用.输入.请输入')+'任务价格'" />
                  </a-form-model-item>
                  <a-form-model-item prop="priceUnit" >
                        <span slot="label" ><a-tooltip>价格单位，例如: 天/次/小时<template slot="title">价格单位，例如: 天/次/小时</template></a-tooltip> </span>
                        <a-input v-model="form.priceUnit" :maxLength="20" :placeholder="$t('通用.输入.请输入')+'价格单位，例如: 天/次/小时'" />
                  </a-form-model-item>
                  <a-form-model-item prop="taskStatus" >
                        <span slot="label" ><a-tooltip>任务状态 0待发布 1进行中 2已完成 3已取消<template slot="title">任务状态 0待发布 1进行中 2已完成 3已取消</template></a-tooltip> </span>
                  </a-form-model-item>
                  <a-form-model-item prop="auditStatus" >
                        <span slot="label" ><a-tooltip>审核状态 0待审核 1通过 2拒绝<template slot="title">审核状态 0待审核 1通过 2拒绝</template></a-tooltip> </span>
                  </a-form-model-item>
                  <a-form-model-item prop="publishTime" >
                        <span slot="label" ><a-tooltip>发布时间<template slot="title">发布时间</template></a-tooltip> </span>
                        <a-date-picker style="width: 100%" v-model="form.publishTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                  </a-form-model-item>
                  <a-form-model-item prop="createdAt" >
                        <span slot="label" ><a-tooltip>创建时间<template slot="title">创建时间</template></a-tooltip> </span>
                        <a-date-picker style="width: 100%" v-model="form.createdAt" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                  </a-form-model-item>
                  <a-form-model-item prop="updatedAt" >
                        <span slot="label" ><a-tooltip>更新时间<template slot="title">更新时间</template></a-tooltip> </span>
                        <a-date-picker style="width: 100%" v-model="form.updatedAt" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                  </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getTaskMain, addTaskMain, updateTaskMain } from '@/api/task/taskMain'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject} from "@/api/tool/oss";


  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
                          id: null,
                          publisherId: null,
                          taskTitle: null,
                          taskDesc: null,
                          taskVideoUrl: null,
                          taskVideoCover: null,
                          voteCount: null,
                          usedVoteCount: null,
                          remainVoteCount: null,
                          province: null,
                          city: null,
                          district: null,
                          detailAddress: null,
                          taskType: null,
                          taskCategory: null,
                          identityTags: null,
                          viewPermission: null,
                          estimatedArrivalMinutes: null,
                          taskPrice: null,
                          priceUnit: null,
                      taskStatus: 0,
                      auditStatus: 0,
                          publishTime: null,
                          createdAt: null,
                          updatedAt: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
                              publisherId: [{ required: true, message: '发布用户ID'+this.$t('通用.文本.不能为空'), trigger: 'blur' }] ,
                              taskType: [{ required: true, message: '任务类型'+this.$t('通用.文本.不能为空'), trigger: 'change' }] ,
                              taskCategory: [{ required: true, message: '任务类别'+this.$t('通用.文本.不能为空'), trigger: 'blur' }] 
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
                          id: null,
                          publisherId: null,
                          taskTitle: null,
                          taskDesc: null,
                          taskVideoUrl: null,
                          taskVideoCover: null,
                          voteCount: null,
                          usedVoteCount: null,
                          remainVoteCount: null,
                          province: null,
                          city: null,
                          district: null,
                          detailAddress: null,
                          taskType: null,
                          taskCategory: null,
                          identityTags: null,
                          viewPermission: null,
                          estimatedArrivalMinutes: null,
                          taskPrice: null,
                          priceUnit: null,
                      taskStatus: 0,
                      auditStatus: 0,
                          publishTime: null,
                          createdAt: null,
                          updatedAt: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getTaskMain({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateTaskMain(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addTaskMain(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
